import { Helmet } from 'react-helmet';
import '../assets/styles/About.css';

function AboutUs() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: About Us</title>
        <meta name="description" content="Learn about RFF Cargo’s history, values, and commitment to logistics excellence." />
      </Helmet>
      <section className="about-us-section py-5">
        <div className="overlay"></div>
        <div className="container position-relative">
          {/* First Section: Image and Progressive Company */}
          <div className="row intro-section mb-5">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src="/assets/images/slider-loading-image1.jpg"
                className="intro-image img-fluid"
                alt="RFF Cargo Logistics"
              />
            </div>
            <div className="col-md-6 intro-content">
              <h2 className="about-title fw-bold mb-4">The Most Progressive Company</h2>
              <div className="intro-text">
                <p>
                  RFF Cargo, founded in 1995, has grown from a small freight forwarding firm in Mombasa, Kenya, to a global logistics leader. Our commitment to innovation drives us to deliver cutting-edge solutions for clients worldwide.
                </p>
                <p>
                  We prioritize sustainability by adopting eco-friendly practices in our operations. This ensures efficient logistics while minimizing environmental impact.
                </p>
                <p>
                  Our customer-centric approach tailors solutions to meet diverse client needs. This flexibility has earned us a reputation for reliability and excellence.
                </p>
                <p>
                  With a global network and local expertise, we connect businesses seamlessly across continents. RFF Cargo continues to set the standard for progressive logistics.
                </p>
              </div>
            </div>
          </div>
          {/* Second Section: Mission, Vision, Objectives, Values and Image */}
          <div className="row values-section">
            <div className="col-md-6 values-content">
              <div className="values-item">
                <h3 className="vision-mission-title">Mission & Vision</h3>
                <p className="vision-mission-text">
                  <strong>Mission:</strong> To provide innovative and sustainable logistics solutions that empower businesses to thrive globally.
                </p>
                <p className="vision-mission-text">
                  <strong>Vision:</strong> To be the world’s leading logistics provider, recognized for excellence, sustainability, and customer satisfaction.
                </p>
              </div>
              <div className="values-item">
                <h3 className="vision-mission-title">Our Objective</h3>
                <ul className="values-list">
                  <li>Enhance operational efficiency through advanced technology.</li>
                  <li>Reduce carbon footprint with eco-friendly practices.</li>
                  <li>Deliver tailored logistics solutions for every client.</li>
                  <li>Expand our global network to new markets.</li>
                  <li>Maintain exceptional customer service standards.</li>
                  <li>Foster a culture of innovation and collaboration.</li>
                </ul>
              </div>
              <div className="values-item">
                <h3 className="vision-mission-title">Our Values</h3>
                <p className="values-paragraph">
                  Integrity guides our actions, ensuring transparency and trust in all our dealings. We are committed to ethical practices and accountability.
                </p>
                <p className="values-paragraph">
                  Excellence drives us to exceed expectations, delivering high-quality services that set industry standards. We embrace innovation to stay ahead.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <img
                src="/assets/images/track-41.jpg"
                className="values-image img-fluid"
                alt="RFF Cargo Operations"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUs;